<template>
    <div>
        <div class="card h-auto card-filled">
            <div
                class="card__text h-100 justify-content-center px-2 px-md-4 py-2 py-md-3"
            >
                <div class="row">
                    <div class="col-12">
                        <p>
                            Geef hieronder aan op welke thema's in Ledennet en
                            EU Legislation Dashboard u per mail wilt worden
                            genotificeerd. Indien u wijzigingen doorvoert, kan
                            dit enkele minuten duren.
                        </p>
                    </div>
                    <div class="col-12 col-lg-6">
                        <h2>Thema's</h2>

                        <toggle-group
                            v-model="myThemes"
                            :options="allThemes"
                        ></toggle-group>
                    </div>

                    <div class="col-12 col-lg-6">
                        <h2>Nieuws</h2>
                        <toggle-group
                            v-model="myNews"
                            :options="allNews"
                        ></toggle-group>
                    </div>
                </div>
            </div>
        </div>
        <div class="card h-auto card-filled">
            <div
                class="card__text h-100 justify-content-center px-2 px-md-4 py-2 py-md-3"
            >
                <div class="row">
                    <div class="col-12">
                        <h2>{{ title }}</h2>
                        <legislation-subscriptions
                            :subscriptions="mySubscriptions"
                        ></legislation-subscriptions>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import toggleGroup from '@/components/form/toggle-group';
import legislationSubscriptions from '@/components/legislationMonitor/legislation-subscriptions';

export default {
    components: {
        toggleGroup,
        legislationSubscriptions
    },

    props: {
        title: {
            type: String,
            default() {
                return 'Legislations';
            }
        }
    },

    data() {
        return {
            firstLoadMyNotifications: true,
            firstLoadGetSubscriptions: true,
            allNews: [],
            allThemes: [],
            myNews: [],
            myThemes: [],
            mySubscriptions: {}
        };
    },
    watch: {
        myNews() {
            if (
                !this.firstLoadMyNotifications &&
                !this.firstLoadGetSubscriptions
            ) {
                this.updateNotificationPreferences();
            }
        },

        myThemes() {
            if (
                !this.firstLoadMyNotifications &&
                !this.firstLoadGetSubscriptions
            ) {
                this.updateNotificationPreferences();
            }
        },

        mySubscriptions() {
            if (
                !this.firstLoadMyNotifications &&
                !this.firstLoadGetSubscriptions
            ) {
                this.updateNotificationPreferences();
            }
        }
    },

    created() {
        this.getNotificationPreferences();
        this.getLegislationSubscriptions();
    },

    methods: {
        getNotificationPreferences() {
            const url = '/api/v1/domainapi/MyNotifications';
            Axios({
                method: 'get',
                url: url
            })
                .then(response => {
                    this.allNews = response.data.all.news;
                    this.allThemes = response.data.all.themes;

                    this.myNews = response.data.my.news;
                    this.myThemes = response.data.my.themes;
                })
                .finally(() => {
                    this.firstLoadMyNotifications = false;
                });
        },

        updateNotificationPreferences() {
            const url = '/api/v1/domainapi/UpdateMyNotifications';
            Axios({
                method: 'post',
                url: url,
                data: {
                    News: this.myNews,
                    Themes: this.myThemes
                }
            });
        },
        getLegislationSubscriptions() {
            const url = '/umbraco/api/legislation/getsubscriptions';
            Axios({
                method: 'get',
                url: url
            })
                .then(response => {
                    this.mySubscriptions = response.data;
                })
                .finally(() => {
                    this.firstLoadGetSubscriptions = false;
                });
        }
    }
};
</script>
